import React from "react";
import { useDndContext, useDroppable } from "@dnd-kit/core";
import {
	ROOT_PARENT,
	ROOT_START_DROP_ZONE_ID,
	ROOT_END_DROP_ZONE_ID,
} from "../utilities/dragUtils";

function BaseRootDropZone({ dropZoneId, variant, title, hint }) {
	const { active } = useDndContext();
	const isDraggingTopLevelItem = Boolean(
		active &&
			active.data &&
			active.data.current &&
			(active.data.current.nodeType === "page" ||
				active.data.current.nodeType === "folder") &&
			active.data.current.parentId === ROOT_PARENT,
	);
	const { setNodeRef, isOver } = useDroppable({
		id: dropZoneId,
		data: { acceptsPage: true },
		disabled: !isDraggingTopLevelItem,
	});

	const className = [
		"root-dropzone",
		`root-dropzone--${variant}`,
		isDraggingTopLevelItem ? "root-dropzone--visible" : "",
		isOver ? "root-dropzone--over" : "",
	]
		.filter(Boolean)
		.join(" ");

	return (
		<div
			ref={setNodeRef}
			className={className}
			aria-hidden={!isDraggingTopLevelItem}
		>
			<div className="root-dropzone__label">
				<span className="root-dropzone__title">{title}</span>
				<span className="root-dropzone__hint">{hint}</span>
			</div>
		</div>
	);
}

/**
 * Provides a clear drop area at the start of the root list.
 * @returns {JSX.Element}
 */
export function RootStartDropZone() {
	return (
		<BaseRootDropZone
			dropZoneId={ROOT_START_DROP_ZONE_ID}
			variant="start"
			title="Move to start of list"
			hint="Drop here to place this item before all others."
		/>
	);
}

/**
 * Provides a clear drop area at the end of the root list.
 * @returns {JSX.Element}
 */
export function RootEndDropZone() {
	return (
		<BaseRootDropZone
			dropZoneId={ROOT_END_DROP_ZONE_ID}
			variant="end"
			title="Move to end of list"
			hint="Drop here to place this item after all others."
		/>
	);
}
